// Defines a default fallback namespace to attempt to load when no other valid
// namespaces are known.
export const defaultNamespace = "default";
